(ns frontend.ui.component.dynamic-table.view
  (:require
   [frontend.ui.component.dynamic-table.style :as style]
   [herb.core :refer [<class]]
   [frontend.ui.component.dynamic-table.heading-row.style :as heading-style]
   [frontend.ui.component.dynamic-table.row.style :as row-style]
   [frontend.ui.component.dynamic-table.row.style-subtotal :as row-style-subtotal]
   [frontend.ui.component.dynamic-table.row.style-subheading :as row-style-subheading]
   [frontend.ui.component.dynamic-table.cell.style :as cell-style]
   [frontend.excel-utils :as exu]
   [frontend.ui.page.lp-portal.report.util :as util]
   [frontend.ui.component.lp-portal.stacked-text-group.view :as stacked-text-group]
   [common.util :as cu]
   [frontend.utils :as fu]))

(defn formatted-cell-data
  [cell-data data-type cell-style]
  (let [formatted-val
        (condp = data-type
          :percentage (util/->percent-1-decimal cell-data)
          :multiplier (util/->multiple cell-data)
          :number (let [data-format-string (str (:data-format-string cell-style))]
                    (if (and (not (cu/blank-value? data-format-string))
                             (not= (cu/str-trim-lcase data-format-string)
                                   "general"))
                      (exu/format-number cell-data data-format-string)
                      (util/->int cell-data)))
          :date
          (let [data-format-string (str (:data-format-string cell-style))
                date-in-millis (exu/excel-date->epoch-ms cell-data)]
            (fu/format-epoch date-in-millis "dd.MM.yyyy")
            #_(if-not (cu/blank-value? data-format-string)
                (:value
                 (js->clj (exu/format-date cell-data data-format-string) :keywordize-keys true))
                (:value
                 (js->clj (exu/format-date cell-data "dd.mm.yyyy") :keywordize-keys true)))

          )                                               ;; TODO - remove hardcoded default
          :string (str cell-data)
          (cond (number? cell-data)
                (util/->int cell-data)
                :else
                cell-data))]
    formatted-val))

(defn dynamic-table-no-headings
  "col-data-types : string -> left align, number -> right align, other???
:ordered-cols => use for headings
:title => top left cell if exists
:data => contains metadata and data contents
:row-style [#. :border-top :double => footer row
               :border-top :single => subtotal
               :bold? => bold text on every cell on row
               :underline? => special heading row
               :next-empty? => make this row bottom padding bigger => i.e. every cell should have bottom padding"
  [{:keys [parsed-data even-row-background-color odd-row-background-color sub-heading-color]
    :as   props}]
  (let [{:keys [ordered-cols col-data-types title data skip-headers?]} parsed-data
        heading-texts (cons title ordered-cols)]
    (if-not ordered-cols
      [:div
       "Incorrect parsed data"
       [:div (pr-str parsed-data)]]

      [:div
       {:class (<class style/scroll-container)}
       [:table
        {:class (<class style/dynamic-table)}
        #_(when-not skip-headers?
            [:thead
             [:tr
              {:class (<class heading-style/heading)
               :style {:background-color odd-row-background-color}}
              [:th
               {:class (<class heading-style/title-cell)}
               ;; TODO - check this is missing from hotels portofolio debt key figures
               title]
              (->> ordered-cols
                   (map-indexed
                    (fn [cell-index heading-text]
                      (let [col-data-type (nth col-data-types cell-index nil)
                            is-last (->> ordered-cols
                                         (count)
                                         (dec)
                                         (= cell-index))]
                        ^{:key cell-index}
                        [:th
                         {:class (<class (if (= :number col-data-type)
                                           heading-style/number-col
                                           heading-style/col))}
                         ;; TODO -> HEADING STYLINGS when numeric -> parser
                         heading-text])))
                   (doall))]])
        [:tbody
         {:class (<class style/tbody)}
         (->> parsed-data
              :data
              (remove nil?)
              (map-indexed
               (fn [row-index row]
                 ^{:key row-index}                          ; For an unknown reason, this is needed twice to avoid Reagent key prop warning.
                 [:tr
                  {:class (row-style/class row
                                           even-row-background-color
                                           odd-row-background-color
                                           sub-heading-color)}
                  [:td
                   {:class (<class cell-style/row-heading)}
                   (:row-key row)]
                  (->> row
                       :row-data
                       (map-indexed
                        (fn [cell-index cell-data]
                          (let [row-style (-> row
                                              :row-style)
                                cell-style (-> row
                                               :cell-styles
                                               (nth cell-index nil))
                                data-type (-> row
                                              :cell-data-types
                                              (nth cell-index nil))]
                            ^{:key cell-index}
                            [:td
                             {:class (cell-style/class cell-data row-style cell-style data-type)}
                             (formatted-cell-data cell-data data-type cell-style)
                            ])))
                       (doall))]))
              (doall))]]])))


(defn dynamic-table
  "col-data-types : string -> left align, number -> right align, other???
  :ordered-cols => use for headings
  :title => top left cell if exists
  :data => contains metadata and data contents
  :row-style [#. :border-top :double => footer row
                 :border-top :single => subtotal
                 :bold? => bold text on every cell on row
                 :underline? => special heading row
                 :next-empty? => make this row bottom padding bigger => i.e. every cell should have bottom padding"
  [{:keys [parsed-data even-row-background-color odd-row-background-color sub-heading-color]
    :as   props}]
  (let [{:keys [ordered-cols col-data-types title data skip-headers?]} parsed-data
        heading-texts (cons title ordered-cols)
        last-heading-idx (atom 0)
        table-style (cond
                      (->> parsed-data
                           :data
                           (remove nil?)
                           (some row-style/sub-heading?))
                      :table-style/subheadings
                      (->> parsed-data
                           :data
                           (remove nil?)
                           (some row-style/sub-total?))
                      :table-style/subtotals
                      :else
                      :table-style/default)]
    (if-not ordered-cols
      [:div
       "Incorrect parsed data"
       [:div (pr-str parsed-data)]]

      [:div
       {:class (<class style/scroll-container)}
       [:table
        {:class (<class style/dynamic-table)}
        (when-not skip-headers?
          [:thead
           [:tr
            {:class (<class heading-style/heading)
             :style {:background-color odd-row-background-color}}
            [:th
             {:class (<class heading-style/title-cell)}
             ;; TODO - check this is missing from hotels portofolio debt key figures

             (or title " ")]
            (->> ordered-cols
                 (map-indexed
                  (fn [cell-index heading-text]
                    (let [col-data-type (nth col-data-types cell-index nil)]
                      ^{:key cell-index}
                      [:th
                       {:class (<class heading-style/th-cell)}
                       (or heading-text " ")])))
                 (doall))]])
        [:tbody
         {:class (<class style/tbody)}
         (->> parsed-data
              :data
              ;; trim empty lines from end
              (reverse)
              (drop-while (fn [r]
                            (nil? r)))
              (reverse)
              (map-indexed
               (fn [row-index row]
                 (let [heading? (row-style/sub-heading? row)
                       sub-total? (row-style/sub-total? row)
                       row-data (:row-data row)
                       row-data (if (= (count row-data) (count ordered-cols))
                                  row-data
                                  (concat row-data
                                          (->> (range 0 (- (count ordered-cols) (count row-data)))
                                               (mapv (fn [_]
                                                       nil)))))]
                   (when heading?
                     (reset! last-heading-idx row-index))
                   ^{:key row-index}                        ; For an unknown reason, this is needed twice to avoid Reagent key prop warning.
                   [:tr
                    {:class (case table-style
                              :table-style/subtotals
                              (row-style-subtotal/class row
                                                        even-row-background-color
                                                        odd-row-background-color
                                                        sub-heading-color)
                              :table-style/subheadings
                              (row-style-subheading/class row
                                                          even-row-background-color
                                                          odd-row-background-color
                                                          sub-heading-color)
                              :table-style/default
                              (row-style/class row
                                               even-row-background-color
                                               odd-row-background-color
                                               sub-heading-color)

                              (row-style/class row
                                               even-row-background-color
                                               odd-row-background-color
                                               sub-heading-color))}
                    [:td
                     {:class (<class cell-style/row-heading)}
                     (:row-key row)]

                    (->> row-data
                         (map-indexed
                          (fn [cell-index cell-data]
                            (let [row-style (-> row
                                                :row-style)
                                  cell-style (-> row
                                                 :cell-styles
                                                 (nth cell-index nil))
                                  data-type (-> row
                                                :cell-data-types
                                                (nth cell-index nil))]
                              ^{:key cell-index}
                              [:td
                               {:class (cell-style/class cell-data row-style cell-style data-type)}
                               (formatted-cell-data cell-data data-type cell-style)
                              ])))
                         (doall))])))
              (doall))]]])))

(defn dynamic-stack
  "Same data schma as in dynamic-table above, only first column data is shown"
  [{:keys [ordered-cols col-data-types title data skip-headers?] :as parsed-data}]
  (if-not ordered-cols
    [:div
     "Incorrect parsed data"
     [:div (pr-str parsed-data)]]
    (->> data
         (remove nil?)
         (map (fn [row]
                (stacked-text-group/stacked-text-group
                 (:row-key row)
                 (let [data-type (-> row
                                     :cell-data-types
                                     (first))
                       cell-style (-> row
                                      :cell-styles
                                      (first))
                       cell-data (-> row
                                     :row-data
                                     (first))]
                   (formatted-cell-data cell-data data-type cell-style)))))
         (into [:div
                {:class (<class style/padding-bottom)}]))))
